"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VPLogo = exports.VPLocalizedLogo = exports.Logos = void 0;
const logo_1 = require("@navigation/logo");
const styled_components_1 = __importDefault(require("styled-components"));
exports.Logos = styled_components_1.default.div `
  display: inline-flex;
  flex-flow: row-reverse;
  box-sizing: border-box;
  width: 100%;
  max-width: 1440px;
  padding: 0;
  margin: ${({ isPrivalia, theme }) => (isPrivalia ? theme.space.s300 : theme.space.s150)} auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    padding: 0 110px;
  }
`;
exports.VPLocalizedLogo = styled_components_1.default.img `
  width: 152px;
  height: ${({ theme }) => theme.space.s600};
  margin-right: ${({ theme }) => theme.space.s300};

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    width: 178px;
    height: ${({ theme }) => theme.space.s700};
  }
`;
exports.VPLogo = (0, styled_components_1.default)(logo_1.Logo) `
  align-self: center;
  width: 190px;
  height: 56px;
  margin-right: ${({ theme }) => theme.space.s400};

  @media screen and (min-width: ${({ theme }) => theme.breakpoint.desktop}) {
    height: ${({ theme }) => theme.space.s400};
    margin-right: 5.75rem;
  }
`;
